import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { PermissionsTypes } from '@gem/call/Model/callPermissions/callPermissionsModel.types';
import { PERMISSIONS_TYPES_TRANSLATIONS } from '@gem/call/constants';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { RadioLabel } from '@gem/ui-kit';

import { useCallChangeDefaultPermissionPopupPresenter } from './CallChangeDefaultPermissionPopup.presenter';
import styles from './CallChangeDefaultPermissionPopup.styles.m.css';
import { ICallChangeDefaultPermissionPopupProps } from './CallChangeDefaultPermissionPopup.types';

const descriptionTranslations = {
  [PermissionsTypes.SwitchOnCamera]: 'call_who_can_switch_camera',
  [PermissionsTypes.SwitchOnMic]: 'call_who_can_switch_mic',
  [PermissionsTypes.ShareScreen]: 'call_who_can_share_screen',
};

export const CallChangeDefaultPermissionPopup: FC<
  ICommonPopupsProps<ICallChangeDefaultPermissionPopupProps>
> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useCallChangeDefaultPermissionPopupPresenter(props);

  if (!presenter.ongoingCall || !props.params?.permissionType) {
    return null;
  }

  return (
    <Popup
      isHidden={props.popupInstance.isHidden}
      title={t(PERMISSIONS_TYPES_TRANSLATIONS[props.params.permissionType])}
      isOpened
      onClose={presenter.onClose}
      handlePrevStep={presenter.goBack}
    >
      <div className={styles.title}>{t(descriptionTranslations[props.params.permissionType])}</div>
      <div className={styles.wrapper}>
        {presenter.permissionValues.map((item) => (
          <RadioLabel {...item} />
        ))}
      </div>
    </Popup>
  );
});
